<template>
    <div>
        <NavigationAction v-show="showReset" label="Reset" @click="reset" />
        <ConfirmDialog acceptLabel="Reset form">
            <template #accepticon>
                <div></div>
            </template>
        </ConfirmDialog>
    </div>
</template>

<script>
import { useRecordTarpingWorksStore } from '@/stores/RecordTarpingWorks';

import ConfirmDialog from 'primevue/confirmdialog';
import NavigationAction from '@/navigation/TopNavigationBar/components/NavigationAction.vue'

export default {
    name: "ResetFormButton",
    components: {
        ConfirmDialog,
        NavigationAction,
    },
    data() { return {
        store: null,
    }},
    created() {
        this.store = useRecordTarpingWorksStore();
    },
    computed: {
        showReset() {
            return this.store.activeStep !== 3;
        }
    },
    methods: {
        reset() {
            this.$confirm.require({
                message: 'Are you sure you want to reset this form? All progress will be lost.',
                header: 'Reset Form',
                acceptClass: 'p-button-danger',
                accept: () => {
                    this.store.reset();
                }
            });
        }
    }
}

</script>